import React from "react";
import { TextWrapper, Wrapper } from "../../constants/common/StyledGlobalConstants";
import PropTypes from "prop-types";

const Chip = ({ status, children, fontSize = "0.75rem", cfst }) => {
  const getBackgroundColor = () => {
    let bgColour = "#FFF";
    if (status === "New" || status === "Assigned" || status === "Troubleshooting" || status === "Scheduled" || status === "Rescheduled") {
      bgColour = "#006FC1";
    } else if (status === "Pending Follow up" || status === "Awaiting your reply") bgColour = "#C44904";
    else if (status === "Pending") bgColour = "#FFBC3D";
    return bgColour;
  };

  return (
    <Wrapper
      // tabIndex={cfst === "true" ? "-1" : "0"}
      display="flex"
      flexDirection="column"
      padding="7.5px 12px"
      justifyContent="center"
      alignItems="center"
      borderRadius="3.5rem"
      background={getBackgroundColor()}
      border={status === "Closed" || status === "Complete" || status === "Cancelled" ? "1px solid #000" : "none"}
      width={"fit-content"}
      height="1.5rem"
      style={{ "text-wrap": "nowrap" }}
    >
      <TextWrapper
        margin="0px"
        fontSize={fontSize}
        fontWeight="400"
        color={status === "Closed" || status === "Complete" || status === "Cancelled" || status === "Pending" ? "#000" : "#FFF"}
        lineHeight="12px"
        aria-label={status}
      >
        <>{children}</>
      </TextWrapper>
    </Wrapper>
  );
};

Chip.propTypes = {
  status: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  fontSize: PropTypes.string.isRequired,
  cfst: PropTypes.string.isRequired,
};

export default Chip;
